import type { IconData } from '@stacksjs/iconify-core'

export const emailChatThink: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2.29 31.235h1.52v-1.52h1.52v-1.52H3.81v-1.53H2.29v1.53H.76v1.52h1.53zm3.04-21.33h1.53v6.1H5.33Zm3.05 16.76v-1.52H9.9v-3.05H8.38v-1.52H5.33v1.52H3.81v3.05h1.52v1.52zm-1.52-10.66h1.52v1.52H6.86Zm0-9.15h1.52v3.05H6.86Zm1.52 10.67H9.9v1.52H8.38Zm0-13.72H9.9v3.05H8.38Zm1.52 15.24h3.05v1.53H9.9Zm1.53-7.62h1.52v1.53h-1.52ZM9.9 2.285h3.05v1.52H9.9Zm3.05-1.52h10.67v1.52H12.95Zm4.57 10.66h1.53v1.53h-1.53Zm-4.57 9.15h10.67v1.52H12.95Zm10.67-1.53h3.05v1.53h-3.05Zm0-7.62h1.52v1.53h-1.52Zm0-9.14h3.05v1.52h-3.05Zm3.05 15.24h1.52v1.52h-1.52Zm0-13.72h1.52v1.53h-1.52Zm1.52 10.67h1.52v3.05h-1.52Zm0-9.14h1.52v3.05h-1.52Zm1.52 3.05h1.53v6.09h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default emailChatThink
